/**
 * Marks copy (or an image) the user locked in the widget so the agent leaves it alone. Written with
 * {@link setElementAttribute} and cleared with {@link removeElementAttributeBySelector}; enforcement
 * lives on the backend (`apps/api/src/tools/email-template/protected-elements.ts` — keep the two
 * attribute names in sync).
 */
export const USER_LOCK_ATTR = 'data-locked';

/** The template author's lock, configured in the Knowledge Hub. Not removable from the widget. */
export const TEMPLATE_LOCK_ATTR = 'do-not-modify';
